/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_DatetimeInputs */

const en_case_field_datetime = /** @type {(inputs: Case_Field_DatetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date & time`)
};

const pt_br2_case_field_datetime = /** @type {(inputs: Case_Field_DatetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data e hora`)
};

/**
* | output |
* | --- |
* | "Date & time" |
*
* @param {Case_Field_DatetimeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_datetime = /** @type {((inputs?: Case_Field_DatetimeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_DatetimeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_datetime(inputs)
	return pt_br2_case_field_datetime(inputs)
});